import React from 'react';
import * as Styles from './IconThumbsDown.styles';

const IconThumbsDown = ({
  testId = 'IconThumbsDown',
  selected,
}) => (
  <Styles.Svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid={testId}
  >
    <g clipPath="url(#clip0_439_7443)">
      <path d="M11.3334 1.33334V8.66667M14.6668 6.53334V3.46667C14.6668 2.71993 14.6668 2.34656 14.5214 2.06135C14.3936 1.81046 14.1896 1.60649 13.9387 1.47866C13.6535 1.33334 13.2802 1.33334 12.5334 1.33334H5.41208C4.43776 1.33334 3.9506 1.33334 3.55713 1.51162C3.21034 1.66876 2.91561 1.92162 2.70757 2.24048C2.47152 2.60226 2.39745 3.08376 2.24929 4.04675L1.90057 6.31342C1.70517 7.58354 1.60747 8.2186 1.79595 8.71274C1.96137 9.14647 2.27251 9.50914 2.67603 9.7386C3.13576 10 3.7783 10 5.06337 10H5.60007C5.97345 10 6.16013 10 6.30273 10.0727C6.42818 10.1366 6.53017 10.2385 6.59408 10.364C6.66677 10.5066 6.66677 10.6933 6.66677 11.0667V13.0228C6.66677 13.9307 7.40271 14.6667 8.31064 14.6667C8.52717 14.6667 8.72344 14.5391 8.81137 14.3413L11.0519 9.30014C11.1538 9.0708 11.2047 8.9562 11.2852 8.87214C11.3564 8.7978 11.4439 8.741 11.5407 8.70614C11.6502 8.66667 11.7757 8.66667 12.0266 8.66667H12.5334C13.2802 8.66667 13.6535 8.66667 13.9387 8.52134C14.1896 8.39354 14.3936 8.18954 14.5214 7.93867C14.6668 7.65347 14.6668 7.28007 14.6668 6.53334Z" stroke={selected ? '#0070D1' : '#4A4A4A'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_439_7443">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </Styles.Svg>
);

export default IconThumbsDown;
